<div class="h-100 w-100 px-2 d-flex flex-row flex-nowrap justify-content-center align-items-center">
    <img style="width: auto; height: 100%;" priority placeholder
        [src]="(('assets.processhelp' | translate) + '?version=' + app.version.server?.version) | safe : 'url'" />
</div>